import React, {FunctionComponent} from 'react';

const styles = require('./logoBox.component.scss');

export interface LogoBoxProps {
    image: string;
    size: 'huge'| 'large' | 'medium' | 'small';

}

export const LogoBox: FunctionComponent<LogoBoxProps> = props => {
    const {size, image} = props;

    return (
        <div className={`${styles.customerLogoBox} ${styles[size]}`}>
            <img className={styles.logoImage} src={image} alt=""/>
        </div>
    );
}